import React from 'react';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';

export default function StepIconSimple(props: any) {
  const { completed, active, icon } = props;

  // Completed → green tick
  if (completed) {
    return (
      <CheckCircleIcon style={{ color: '#2e7d32', fontSize: 22 }} />
    );
  }

  // Active (current step) → blue
  if (active) {
    return (
      <div
        style={{
          width: 25,
          height: 25,
          borderRadius: '50%',
          background: '#1A9FE0',
          color: '#fff',
          fontSize: 12,
          fontWeight: 700,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        {icon}
      </div>
    );
  }

  // Pending → grey
  return (
    <div
      style={{
        width: 25,
        height: 25,
        borderRadius: '50%',
        background: '#e0e0e0',
        color: '#616161',
        fontSize: 12,
        fontWeight: 500,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      {icon}
    </div>
  );
}
